import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {from, Observable, of, throwError} from 'rxjs';
import {AuthService} from '../auth/AuthService';
import {Router} from '@angular/router';
import {iClient} from '../Model/ClientModel';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private httpClient: HttpClient,
              private authService: AuthService,
              private router: Router) {
  }

  getHomeReports(params?:any): Observable<any> {
    return this.authService.getP(`${environment.reportService}verification`, params);
  }
  getAdminHomeReports(params?:any): Observable<any> {
    return this.authService.getP(`${environment.reportService}verification`, params);
  }
  getMangerHomeReports(params?:any): Observable<any> {
    return this.authService.getP(`${environment.reportService}verification`, params);
  }

  getExtractionMetrics(body?:any): Observable<any> {
    return this.authService.post(`${environment.reportService}verification/extractor-detail`, body);
  }

  getExportFile(body?: any, params?: any): Observable<any> {
    // Correctly calling the Reports API
    return this.authService.getPDF(`${environment.reportService}generateReport`,body,  params);
  }

  getHeaders(params?:any):Observable<any> {
    return this.authService.getP(`${environment.reportService}reportheader`, params);
  }

  getReport(params?:any):Observable<any> {
    return this.authService.getP(`${environment.reportService}generateReport`, params);
  }

  postHeaders(body?:any):Observable<any> {
    return this.authService.post(`${environment.reportService}reportheader`, body);
  }

}
